import { message, notification } from 'antd';

// Global configuration for notifications and messages
const configureNotifications = () => {
    // Configure message global settings
    message.config({
        duration: 3,
        maxCount: 3,
        placement: 'top',
        top: 80,
    });

    // Configure notification global settings
    notification.config({
        duration: 4.5,
        placement: 'topRight',
        maxCount: 3,
        top: 80,
    });
};

let messageApi = message;
let notificationApi = notification;

export const setAntdInstances = (msg, notif) => {
    messageApi = msg;
    notificationApi = notif;
};

// Theme-aware message wrappers
export const showMessage = {
    success: (content, duration = 3, options = {}) => {
        if (typeof content === 'object' && content !== null && !content.$$typeof) {
            return messageApi.success({
                className: 'custom-message-success',
                ...content,
            });
        }
        return messageApi.success({
            content,
            duration,
            className: 'custom-message-success',
            ...options,
        });
    },
    error: (content, duration = 5, options = {}) => {
        if (typeof content === 'object' && content !== null && !content.$$typeof) {
            return messageApi.error({
                className: 'custom-message-error',
                ...content,
            });
        }
        return messageApi.error({
            content,
            duration,
            className: 'custom-message-error',
            ...options,
        });
    },
    warning: (content, duration = 4, options = {}) => {
        if (typeof content === 'object' && content !== null && !content.$$typeof) {
            return messageApi.warning({
                className: 'custom-message-warning',
                ...content,
            });
        }
        return messageApi.warning({
            content,
            duration,
            className: 'custom-message-warning',
            ...options,
        });
    },
    info: (content, duration = 3, options = {}) => {
        if (typeof content === 'object' && content !== null && !content.$$typeof) {
            return messageApi.info({
                className: 'custom-message-info',
                ...content,
            });
        }
        return messageApi.info({
            content,
            duration,
            className: 'custom-message-info',
            ...options,
        });
    },
    loading: (content, duration = 0, options = {}) => {
        if (typeof content === 'object' && content !== null && !content.$$typeof) {
            return messageApi.loading({
                className: 'custom-message-loading',
                ...content,
            });
        }
        return messageApi.loading({
            content,
            duration,
            className: 'custom-message-loading',
            ...options,
        });
    },
    destroy: (key) => {
        messageApi.destroy(key);
    },
};

// Theme-aware notification wrappers
export const showNotification = {
    success: (message, description, options = {}) => {
        if (typeof message === 'object' && message !== null && !message.$$typeof) {
            return notificationApi.success({
                duration: 4.5,
                className: 'custom-notification-success',
                ...message,
            });
        }
        return notificationApi.success({
            message,
            description,
            duration: 4.5,
            className: 'custom-notification-success',
            ...options,
        });
    },
    error: (message, description, options = {}) => {
        if (typeof message === 'object' && message !== null && !message.$$typeof) {
            return notificationApi.error({
                duration: 10,
                className: 'custom-notification-error',
                ...message,
            });
        }
        return notificationApi.error({
            message,
            description,
            duration: 10,
            className: 'custom-notification-error',
            ...options,
        });
    },
    warning: (message, description, options = {}) => {
        if (typeof message === 'object' && message !== null && !message.$$typeof) {
            return notificationApi.warning({
                duration: 6,
                className: 'custom-notification-warning',
                ...message,
            });
        }
        return notificationApi.warning({
            message,
            description,
            duration: 6,
            className: 'custom-notification-warning',
            ...options,
        });
    },
    info: (message, description, options = {}) => {
        if (typeof message === 'object' && message !== null && !message.$$typeof) {
            return notificationApi.info({
                duration: 4.5,
                className: 'custom-notification-info',
                ...message,
            });
        }
        return notificationApi.info({
            message,
            description,
            duration: 4.5,
            className: 'custom-notification-info',
            ...options,
        });
    },
    open: (config = {}) => {
        return notificationApi.open({
            duration: 4.5,
            ...config,
        });
    },
    destroy: (key) => {
        notificationApi.destroy(key);
    },
};

// Destroy all notifications and messages
export const destroyAllNotifications = () => {
    message.destroy();
    notification.destroy();
};

const notificationHelper = {
    showMessage,
    showNotification,
    destroyAllNotifications,
    configureNotifications,
};

export default notificationHelper;
